export default "__VITE_ASSET__eefd551c__"